// extracted by mini-css-extract-plugin
export default {"-large":"P_0GpJ2TaTjD0HfHpMCt","overlay":"XvWTV71V9PGZ9Xqo3SMb"};